$(document).ready(function(){

   /* Build main product item from form (variant id, quantity, properties, selling_plan).
      selling_plan = Shopify subscription/recurring plan ID when product has subscription options. */
   function buildMainItemFromForm(formId) {
      var $form = $('#' + formId);
      var arr = $form.serializeArray();
      var item = { properties: {} };
      for (var i = 0; i < arr.length; i++) {
        var p = arr[i];
        if (p.name === 'id') {
          item.id = parseInt(p.value, 10);
        } else if (p.name === 'quantity') {
          item.quantity = parseInt(p.value, 10) || 1;
        } else if (p.name === 'selling_plan') {
          var sp = parseInt(p.value, 10);
          if (sp > 0) item.selling_plan = sp;
        } else if (p.name.indexOf('properties[') === 0) {
          var key = p.name.replace(/^properties\[|\]$/g, '');
          item.properties[key] = p.value;
        }
      }
      if (!item.id) { var $id = $form.find('[name="id"]'); if ($id.length) item.id = parseInt($id.val(), 10); }
      if (!item.quantity) item.quantity = 1;
      if (Object.keys(item.properties).length === 0) delete item.properties;
      return item;
   }

   /* Build extra items from DOM (gift, promo, gift wrap, cover) - returns array to push into items */
   function buildExtrasFromDOM() {
      var items = [];
      var qtyEl = document.getElementById("quantity");
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

      function el(id) { return document.getElementById(id); }

      /* Gift with purchase */
      if (el("giftwithpurchase") && el("giftwithpurchase").checked && el("giftwithpurchase_values") && el("gift_id")) {
        items.push({
          quantity: qty,
          id: parseInt(el("giftwithpurchase_values").value, 10),
          properties: { '_Gift ID Depend': el("gift_id").value }
        });
        if (el("giftwithpurchase_values_2")) {
          items.push({
            quantity: qty,
            id: parseInt(el("giftwithpurchase_values_2").value, 10),
            properties: { '_Gift ID Depend': el("gift_id").value }
          });
        }
      }

      /* Promo with purchase */
      if (el("promowithpurchase") && el("promowithpurchase").checked && el("promowithpurchase_values") && el("promo_id")) {
        var promoProps = { '_Promo ID Depend': el("promo_id").value };
        if (el("promowithpurchase_values").getAttribute("data-dropship") === 'true') {
          promoProps['Delivery Estimate'] = 'up to 14 business days';
          promoProps['Delivery'] = 'shipped from manufacturer';
        }
        items.push({ quantity: qty, id: parseInt(el("promowithpurchase_values").value, 10), properties: promoProps });
        if (el("promowithpurchase_values_2")) {
          var promo2Props = { '_Promo ID Depend': el("promo_id").value };
          if (el("promowithpurchase_values_2").getAttribute("data-dropship") === 'true') {
            promo2Props['Delivery Estimate'] = 'up to 14 business days';
            promo2Props['Delivery'] = 'shipped from manufacturer';
          }
          items.push({ quantity: qty, id: parseInt(el("promowithpurchase_values_2").value, 10), properties: promo2Props });
        }
      }

      /* Gift wrap service */
      if (el("giftwrapservice") && el("giftwrapservice").checked && el("gift_wrapping_id")) {
        var gwProps = { '_Gift Wrapping ID Depend': el("gift_wrapping_id").value };
        if (el('gift_wrap_promo')) { gwProps['_Gift Wrapping Promo'] = 'Free'; }
        items.push({ quantity: qty, id: parseInt(el("giftwrapservice").value, 10), properties: gwProps });
      }

      /* Cover with purchase */
      if (el("coverwithpurchase") && el("coverwithpurchase").checked && el("coverwithpurchase_values") && el("cover_id")) {
        items.push({
          quantity: qty,
          id: parseInt(el("coverwithpurchase_values").value, 10),
          properties: { '_Cover ID Depend': el("cover_id").value }
        });
      }

      return items;
   }

   /* Build stringing items for racquet products (Regular or Hybrid) - returns array to prepend */
   function buildStringingItems() {
      var assign = Object.assign || function(t) { for (var s, i = 1, n = arguments.length; i < n; i++) { s = arguments[i]; for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) t[k] = s[k]; } } return t; };
      var items = [];
      var el = function(id) { return document.getElementById(id); };
      var qtyEl = el("quantity");
      var multEl = el("quantity_multiplier");
      var qty = (parseInt(qtyEl && qtyEl.value, 10) || 1) * (parseInt(multEl && multEl.value, 10) || 1);
      var bundleId = el("bundle_id") && el("bundle_id").value;
      var stringingNote = (el("stringing_note") && el("stringing_note").value) || '';
      var stringType = el("stringservicetype") && el("stringservicetype").value;
      if (!bundleId || !stringType) return items;

      var baseProps = { '_Stringing ID Depend': bundleId, '_ASRC': 'Final Sale' };

      if (stringType === "Regular String" && el("string-options")) {
        var stringId = parseInt(el("string-options").options[el("string-options").selectedIndex].title, 10);
        items.push({ quantity: qty, id: stringId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
        items.push({ quantity: qty, id: stringId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
      } else if (stringType === "Hybrid String" && el("string-options-main") && el("string-options-cross")) {
        var mainId = parseInt(el("string-options-main").options[el("string-options-main").selectedIndex].title, 10);
        var crossId = parseInt(el("string-options-cross").options[el("string-options-cross").selectedIndex].title, 10);
        items.push({ quantity: qty, id: mainId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
        items.push({ quantity: qty, id: crossId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
      } else {
        return items;
      }

      items.push({ quantity: qty, id: 1226716373, properties: { '_Stringing ID Depend': bundleId, 'Stringing Notes': stringingNote, '_ASRC': 'Final Sale' } });
      return items;
   }

   /* Demo racquet: service fee variant – add only once (when no demos/fee in cart yet) */
   var DEMO_SERVICE_FEE_VARIANT_ID = 22430097031;
   function buildDemoItem() {
      return { quantity: 1, id: DEMO_SERVICE_FEE_VARIANT_ID };
   }
   function cartHasDemoServiceFee(cart) {
      if (!cart || !cart.items) return false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === DEMO_SERVICE_FEE_VARIANT_ID) return true;
      }
      return false;
   }

   function addItem(form_id, prependItems, clickedElem, maxQtyPerAdd) {
      var mainItem = buildMainItemFromForm(form_id);
      var extras = buildExtrasFromDOM();
      var items = (prependItems && prependItems.length ? prependItems : []).concat([mainItem]).concat(extras);
      if (maxQtyPerAdd && maxQtyPerAdd > 0) {
        items.forEach(function(it) { it.quantity = Math.min(parseInt(it.quantity, 10) || 1, maxQtyPerAdd); });
      }
      items.forEach(function(it) { if (it.properties && Object.keys(it.properties).length === 0) delete it.properties; });

      var totalQty = items.reduce(function(sum, it) { return sum + (parseInt(it.quantity, 10) || 1); }, 0);

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart/add.js') : '/cart/add.js';
      var reqComplete = false;
      $.ajax({
        type: 'POST',
        url: cartAddUrl,
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        dataType: 'json',
        success: function(response) {
          reqComplete = true;
          /* Success returns item/line_item; errors have status, message, description (success never has description) */
          var isError = response && (
            response.status === 422 ||
            response.status >= 400 ||
            response.message === 'Cart Error' ||
            (response.description && typeof response.description === 'string' && response.description.length > 0)
          );
          if (isError) {
            Shopify.onError({ responseText: JSON.stringify(response) }, 'error', 'Cart error', clickedElem);
          } else {
            Shopify.onSuccess(response, totalQty, clickedElem);
          }
        },
        error: function(xhr, textStatus, errorThrown) { reqComplete = true; Shopify.onError(xhr, textStatus, errorThrown, clickedElem); }
      });
      window.setTimeout(function() {
        if (!reqComplete && clickedElem && clickedElem.length) {
          reqComplete = true;
          Shopify.onError({ responseText: '{}' }, 'timeout', 'Request timed out', clickedElem);
        }
      }, 15000);
   }

   function guid() {
      return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
   }
   function refreshBundleIds() {
      var b = guid();
      var el = function(id) { return document.getElementById(id); };
      if (el("bundle_id")) el("bundle_id").value = b;
      if (el("gift_id")) el("gift_id").value = b;
      if (el("promo_id")) el("promo_id").value = b;
      if (el("gift_wrapping_id")) el("gift_wrapping_id").value = b;
      if (el("cover_id")) el("cover_id").value = b;
   }

   $(".addtocart").click(function(e){
      e.preventDefault();
      var elem = $(this);
      refreshBundleIds();

      /* Demo terms: require "I agree" checkbox when present */
      var $demoAgree = $('#demoserviceagree');
      if ($demoAgree.length && !$demoAgree.is(':checked')) {
        elem.prop("disabled", false).val('Add to Cart');
        Shopify.showAddToCartError('You must agree to the demo terms before adding to cart.', 'main', true, 'demo-terms');
        return;
      }

      elem.val('Adding...').prop("disabled", true);

      function doAddToCart(prependItemsOverride) {
        var t = addstring();
        if (t) {
          var productType = document.getElementById("product_type") && document.getElementById("product_type").value;
          var stringServiceType = document.getElementById("stringservicetype") && document.getElementById("stringservicetype").value;
          var prependItems;

          if (prependItemsOverride !== undefined) {
            prependItems = prependItemsOverride;
          } else {
            prependItems = [];
            if (productType === "racquets" && (stringServiceType === "Regular String" || stringServiceType === "Hybrid String")) {
              prependItems = buildStringingItems();
            } else if (productType === "demo-racquet") {
              prependItems = [buildDemoItem()];
            }
          }

          addItem('add-item-form', prependItems.length ? prependItems : null, elem, shopAddLimit);
        } else {
          elem.prop("disabled", false).val('Add to Cart');
        }
      }

      /* Tag-based quantity limit, inventory pre-check, demo service-fee check, and shop add-to-cart limit */
      var $form = $('#add-item-form');
      var limit = parseInt($form.attr('data-quantity-limit') || 0, 10);
      var productId = parseInt($form.attr('data-product-id') || 0, 10);
      var shopAddLimit = parseInt($form.attr('data-shop-add-limit') || 0, 10);
      var mainItem = buildMainItemFromForm('add-item-form');
      var requestedQty = mainItem.quantity || 1;
      if (shopAddLimit > 0 && requestedQty > shopAddLimit) {
        var qtyEl = document.getElementById('quantity');
        if (qtyEl) qtyEl.value = shopAddLimit;
        requestedQty = shopAddLimit;
        /* When cart is empty, callback won't cap (200 == 200); set message here. Callback overwrites when cart has items. */
        Shopify._pendingLimitMessage = { added: shopAddLimit, limit: shopAddLimit, target: (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main', isShopLimit: true };
      }

      var variantId = parseInt($form.attr('data-variant-id') || 0, 10) || (mainItem.id || 0) || parseInt($('#product-select').val() || 0, 10);
      var inventoryMax = parseInt($form.attr('data-variant-inventory') || 0, 10);
      var inventoryPolicy = ($form.attr('data-inventory-policy') || '').toLowerCase();
      var inventoryMgmt = ($form.attr('data-inventory-management') || '').toLowerCase();

      /* Fallback: get variant inventory from product JSON when form attrs not set (e.g. demo-racquet, multi-option) */
      if (variantId > 0 && (isNaN(inventoryMax) || inventoryPolicy === '' || inventoryMgmt === '')) {
        var variants = (window.Shopify && window.Shopify._productVariants) || [];
        var vidNum = typeof variantId === 'number' ? variantId : parseInt(variantId, 10);
        for (var vi = 0; vi < variants.length; vi++) {
          var vId = variants[vi].id;
          if (vId == vidNum || vId === variantId) {
            var v = variants[vi];
            if (inventoryMgmt === '') inventoryMgmt = (v.inventory_management || '').toLowerCase();
            if (inventoryPolicy === '') inventoryPolicy = (v.inventory_policy || '').toLowerCase();
            if (isNaN(inventoryMax) && v.inventory_quantity != null) inventoryMax = parseInt(v.inventory_quantity, 10);
            break;
          }
        }
      }
      var inventoryCheckNeeded = variantId > 0 && !isNaN(inventoryMax) && inventoryMax >= 0 && inventoryMgmt === 'shopify' && inventoryPolicy !== 'continue';
      var productType = document.getElementById("product_type") && document.getElementById("product_type").value;
      var needsCartForDemoFee = productType === 'demo-racquet';

      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart.js') : '/cart.js';

      if ((limit > 0 && productId > 0) || inventoryCheckNeeded || needsCartForDemoFee || shopAddLimit > 0) {
        var target = (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main';
        $.getJSON(cartUrl, function(cart) {
          var prependOverride;
          if (needsCartForDemoFee) {
            var hasFee = cartHasDemoServiceFee(cart);
            prependOverride = hasFee ? [] : [buildDemoItem()];

            /* Demo racquet: max 1 per variant – allow 1 of each available variant (e.g. different grip/stringing) */
            var demoVariantQty = 0;
            for (var di = 0; di < cart.items.length; di++) {
              if (cart.items[di].variant_id === variantId) demoVariantQty += cart.items[di].quantity;
            }
            if (demoVariantQty >= 1) {
              Shopify.onError({ responseText: JSON.stringify({ description: 'This demo variant is already in your cart.' }) }, 'demo', 'Demo limit', elem);
              return;
            }
          }

          /* Shop limit: already at max – block; would exceed – cap to remaining and add */
          if (shopAddLimit > 0) {
            var variantCartQtyForShop = 0;
            for (var si = 0; si < cart.items.length; si++) {
              if (cart.items[si].variant_id === variantId) variantCartQtyForShop += cart.items[si].quantity;
            }
            if (variantCartQtyForShop >= shopAddLimit) {
              Shopify.onError({
                responseText: JSON.stringify({ description: 'Maximum ' + shopAddLimit + ' per order. You have the maximum in your cart.' })
              }, 'main', 'Shop limit', elem);
              return;
            }
            var shopRemaining = shopAddLimit - variantCartQtyForShop;
            if (requestedQty > shopRemaining) {
              requestedQty = shopRemaining;
              var qtyElShop = document.getElementById('quantity');
              if (qtyElShop) qtyElShop.value = shopRemaining;
              Shopify._pendingLimitMessage = { added: shopRemaining, limit: shopAddLimit, target: target, isShopLimit: true };
            }
          }

          /* Tag-based limit check */
          if (limit > 0 && productId > 0) {
            var cartQty = 0;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].product_id === productId) cartQty += cart.items[i].quantity;
            }
            var remaining = limit - cartQty;
            if (remaining <= 0) {
              Shopify.onError({
                responseText: JSON.stringify({ description: 'The maximum quantity of this item is already in your cart.' })
              }, 'limit', 'Quantity limit', elem);
              return;
            }
            if (requestedQty > remaining) {
              var qtyEl = document.getElementById('quantity');
              if (qtyEl) qtyEl.value = remaining;
              Shopify._pendingLimitMessage = { added: remaining, limit: limit, target: target };
            }
          }

          /* Inventory pre-check: variant stock limit (no overselling). Effective avail = min(inventory, shop limit remaining). When over limit, cap and add with warning (don't block). */
          if (inventoryCheckNeeded) {
            var variantCartQty = 0;
            for (var j = 0; j < cart.items.length; j++) {
              if (cart.items[j].variant_id === variantId) variantCartQty += cart.items[j].quantity;
            }
            var inventoryAvail = inventoryMax - variantCartQty;
            var shopRemaining = shopAddLimit > 0 ? Math.max(0, shopAddLimit - variantCartQty) : inventoryAvail;
            var effectiveAvail = Math.min(inventoryAvail, shopRemaining);
            var totalWouldBe = variantCartQty + requestedQty;
            if (totalWouldBe > inventoryMax || (shopAddLimit > 0 && variantCartQty + requestedQty > shopAddLimit)) {
              if (effectiveAvail <= 0) {
                var msg = shopAddLimit > 0 && variantCartQty >= shopAddLimit
                  ? 'Maximum ' + shopAddLimit + ' per order. You have the maximum in your cart.'
                  : 'Only ' + inventoryMax + ' available. You have the maximum in your cart already.';
                Shopify.onError({ responseText: JSON.stringify({ description: msg }) }, 'inventory', 'Stock limit', elem);
                return;
              }
              /* Cap to effectiveAvail and add with warning */
              requestedQty = effectiveAvail;
              var qtyElInv = document.getElementById('quantity');
              if (qtyElInv) qtyElInv.value = effectiveAvail;
              Shopify._pendingLimitMessage = { added: effectiveAvail, limit: (inventoryAvail <= shopRemaining ? inventoryMax : shopAddLimit), target: target, isShopLimit: (shopRemaining < inventoryAvail), isInventoryLimit: (inventoryAvail <= shopRemaining) };
            }
          }

          doAddToCart(prependOverride);
        }).fail(function() {
          elem.prop("disabled", false).val('Add to Cart');
          Shopify.onError({ responseText: JSON.stringify({ description: 'Unable to check cart. Please try again.' }) }, 'error', 'Cart error', elem);
        });
      } else {
        doAddToCart();
      }
   });

   /* Dismiss demo-terms error when user checks the box during timeout */
   $(document).on('change', '#demoserviceagree', function() {
      if ($(this).is(':checked') && typeof Shopify !== 'undefined' && Shopify.dismissAddToCartError) {
        Shopify.dismissAddToCartError('demo-terms');
      }
   });

   Shopify.onSuccess = function(response, expectedQty, clickedElem) {
      var elem = (clickedElem && clickedElem.length) ? clickedElem : $('.addtocart');

      /* Use expectedQty when passed (includes prior stringing/demo items), else derive from response */
      var quantity = 1;
      if (expectedQty && expectedQty > 0) {
        quantity = expectedQty;
      } else if (response && response.items && response.items.length) {
        quantity = response.items.reduce(function(sum, item) { return sum + (parseInt(item.quantity, 10) || 0); }, 0);
      } else if (response && (typeof response.quantity === 'number' || response.quantity)) {
        quantity = parseInt(response.quantity, 10) || 1;
      } else {
        quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
      }

      /* Success feedback: "Added!", colour wipe in, hold 2.5s, wipe out, then restore */
      elem.val('Added!').addClass('addtocart-added-success').prop("disabled", true);
      window.setTimeout(function() {
        elem.addClass('addtocart-removing');
        elem.one('animationend', function() {
          elem.removeClass('addtocart-added-success addtocart-removing').prop("disabled", false).val('Add to Cart');
        });
      }, 2500);

      /* Fetch real cart count and update display */
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart.js') : '/cart.js';
      $.getJSON(cartUrl, function(cart) {
        $('#cart-count').text(cart.item_count);
        if (typeof appendCartCountToVariantInventory === 'function') {
          var variantId = parseInt($('#add-item-form').find('[name="id"]').val(), 10);
          appendCartCountToVariantInventory(variantId);
        }
      });

      /* Show limit message and reset quantity if we capped on the add */
      if (Shopify._pendingLimitMessage) {
        var pm = Shopify._pendingLimitMessage;
        Shopify._pendingLimitMessage = null;
        /* Use actual quantity added (never show more than what went to cart) */
        var displayedAdded = Math.min(pm.added, quantity);
        var limitMsg = pm.isShopLimit
          ? 'Only ' + displayedAdded + ' could be added (maximum ' + pm.limit + ' per order).'
          : pm.isInventoryLimit
            ? 'Only ' + displayedAdded + ' could be added (inventory is currently limited to ' + pm.limit + ').'
            : 'Only ' + displayedAdded + ' could be added (limited to ' + pm.limit + ').';
        Shopify.showAddToCartError(limitMsg, pm.target, true);
        var qtyEl = document.getElementById('quantity');
        if (qtyEl) qtyEl.value = 1;
      }

      /* Run fly-to-cart animation in parallel (non-blocking) */
      function animate() {
        var $cartAnim = $("#cart-animation");
        var $cartTarget = $("#cart-target");
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduceMotion ? 0 : 800;
        var fadeDuration = reduceMotion ? 0 : 300;

        $cartAnim.text(quantity).show();
        if (reduceMotion) {
          $cartAnim.hide();
          return;
        }
        if (!$cartTarget.length) {
          $cartAnim.hide();
          return;
        }

        $cartAnim.css('will-change', 'transform');
        var addtocartWidth = elem.outerWidth() / 2;
        var addtocartHeight = elem.outerHeight() / 2;
        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight;
        var targetWidth = $cartTarget.outerWidth();
        var buttonAreaLeft = ($cartTarget.offset().left + targetWidth / 2 - $cartAnim.outerWidth() / 2) - 4;
        var buttonAreaTop = ($cartTarget.offset().top + targetWidth / 2 - $cartAnim.outerHeight() / 2) - 4;

        var path = {
          start: { x: addtocartLeft, y: addtocartTop, angle: 190.012, length: 0.2 },
          end: { x: buttonAreaLeft, y: buttonAreaTop, angle: 90.012, length: 0.50 }
        };

        $cartAnim.animate(
          { path: new $.path.bezier(path) },
          duration,
          function() {
            $cartAnim.css('will-change', 'auto');
            $cartAnim.fadeOut(fadeDuration);
          }
        );
      }
      animate();
    };
  
    /* Unified error display for add-to-cart, quantity limits, and quantity validation. Appends new messages when box is already visible unless replace is true. */
    var _addtocartErrorHideTimeout = null;
    var _addtocartErrorKey = null;
    Shopify.showAddToCartError = function(msg, target, replace, errorKey) {
      target = target || 'main';
      var $mainErr = $('#addtocart-error-main');
      var $stringErr = $('#addtocart-error-stringing');
      var $target = (target === 'stringing' && $stringErr.length) ? $stringErr : $mainErr;
      var $other = (target === 'stringing') ? $mainErr : $stringErr;
      if (!$target.length) return;
      if (_addtocartErrorHideTimeout) { clearTimeout(_addtocartErrorHideTimeout); _addtocartErrorHideTimeout = null; }
      $other.hide().empty().css('display', 'none');
      _addtocartErrorKey = errorKey || null;

      var escapedMsg = (msg + '').replace(/</g, '&lt;');
      var $text = $target.find('.addtocart-error-text').first();
      var isVisible = !replace && $target.css('display') !== 'none' && $text.length;
      var existing = $text.length ? $text.html() : '';
      var isDuplicate = isVisible && existing && (existing === escapedMsg || existing.indexOf(escapedMsg) !== -1);

      if (isVisible && $text.length && !isDuplicate) {
        $text.html(existing + '<br>' + escapedMsg);
      } else if (isDuplicate) {
        /* Same message already shown – just reset the hide timeout, don't stack */
      } else {
        var errHtml = '<i class="fas fa-exclamation-triangle"></i><span class="addtocart-error-text">' + escapedMsg + '</span>';
        $target.html(errHtml).css('display', 'block');
        if (errorKey) $target.attr('data-error-key', errorKey);
      }
      $target[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      _addtocartErrorHideTimeout = setTimeout(function() {
        $target.fadeOut(300, function() { $(this).empty().removeAttr('data-error-key').css('display', 'none'); _addtocartErrorKey = null; });
        _addtocartErrorHideTimeout = null;
      }, 8000);
    };

    Shopify.dismissAddToCartError = function(onlyIfKey) {
      if (onlyIfKey && _addtocartErrorKey !== onlyIfKey) return;
      if (_addtocartErrorHideTimeout) { clearTimeout(_addtocartErrorHideTimeout); _addtocartErrorHideTimeout = null; }
      var $mainErr = $('#addtocart-error-main');
      var $stringErr = $('#addtocart-error-stringing');
      [ $mainErr, $stringErr ].forEach(function($el) {
        if ($el.length && (!onlyIfKey || $el.attr('data-error-key') === onlyIfKey)) {
          $el.fadeOut(200, function() { $(this).empty().removeAttr('data-error-key').css('display', 'none'); });
        }
      });
      _addtocartErrorKey = null;
    };

    Shopify.onError = function(xhr, textStatus, errorThrown, clickedElem) {
      var elem = (clickedElem && clickedElem.length) ? clickedElem.first() : $('.addtocart').first();
      elem.prop("disabled", false).val('Add to Cart');

      var data = {};
      try { data = JSON.parse((xhr && xhr.responseText) || '{}'); } catch (e) {}
      var msg = (data && data.description) || (data && data.message) || (data && data.errors) || 'Unable to add to cart. Please try again.';
      if (typeof msg === 'object') msg = (msg.message || msg.description || JSON.stringify(msg));
      if (!(xhr && xhr.responseText) && errorThrown) {
        msg = 'Network error' + (errorThrown ? ': ' + errorThrown : '') + '. Please check your connection and try again.';
      } else if (data && data.message && data.description && data.message !== data.description) {
        msg = data.message + (data.status ? ' (' + data.status + ')' : '') + ': ' + data.description;
      } else if (data && data.message && !data.description) {
        msg = data.message + (data.status ? ' (' + data.status + ')' : '');
      }
      var alt = (Shopify && Shopify.fullMessagesFromErrors) ? Shopify.fullMessagesFromErrors(data) : [];
      if (alt && alt.length && !(data && (data.description || data.message))) { msg = 'Error: ' + alt.join('; '); }

      var target = (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main';
      Shopify.showAddToCartError(msg, target);
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      if (!errors || typeof errors !== 'object') return fullMessages;
      jQuery.each(errors, function(attribute, messages) {
        if (Array.isArray(messages)) {
          jQuery.each(messages, function(index, message) {
            fullMessages.push(attribute + ' ' + message);
          });
        } else if (messages != null && typeof messages === 'object') {
          jQuery.each(messages, function(index, message) {
            fullMessages.push(attribute + ' ' + message);
          });
        } else if (attribute !== 'status' && (typeof messages === 'string' || typeof messages === 'number')) {
          fullMessages.push(attribute + ' ' + messages);
        }
      });
      return fullMessages;
    };

  /* Accordion (service_click, review_click): capture phase - slideToggle. Toggle class in callback to avoid CSS fighting animation. */
  document.addEventListener('mousedown', function(e) {
    var header = e.target.closest && e.target.closest('.service_click, .review_click');
    if (!header) return;
    if (e.which !== 1 && e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    var $h = $(header);
    var $content = $h.next();
    var duration = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 0 : 400;
    if ($h.hasClass('click_opened')) {
      $content.slideUp(duration, function() { $h.removeClass('click_opened').addClass('click_closed'); });
    } else {
      $content.slideDown(duration, function() { $h.removeClass('click_closed').addClass('click_opened'); });
    }
  }, true);

});


jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
    if($(this).attr("value") == "#") return false;
    window.location = $(this).attr("value");
  });

  
});


/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
  if ($(window).width() > 782) {jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_master', '') } );}  
  
};

   
jQuery(document).ready(function($){
      
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.featured img')[0]);
  } );
  
  
  /* Initialize zoom on main product image */
  var mainProductImage = $('.featured img');
  if (mainProductImage.size()) {
    if ($(window).width() > 782) {
    var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
    $('.featured img')
      .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
      .css('display', 'block')
      .parent()
      .zoom( { url: zoomedSrc } );
  }
  }
  
  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    var scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var x = css.x - scrollX;
    var y = css.y - scrollY;
    fx.elem.style.position = 'fixed';
    fx.elem.style.left = '0';
    fx.elem.style.top = '0';
    fx.elem.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    if ( css.prevX != null ) {
      fx.elem.style.transform += ' rotate(' + Math.atan2(css.prevY - css.y, css.prevX - css.x) + 'rad)';
    }
  };
 
})(jQuery);
